import { analytics } from '@client/analytics';

import type { QuestionnaireAnswers } from '@shared';

const CATEGORY = 'engagement';

export function trackQuestionViewed(questionId: string): void {
  analytics.track('advisor_onboarding_questionnaire_question_viewed', { questionId }, CATEGORY);
}

export function trackQuestionAnswered(
  questionId: string,
  patch: Partial<QuestionnaireAnswers>,
): void {
  analytics.track(
    'advisor_onboarding_questionnaire_question_answered',
    { questionId, patch: patch as Record<string, unknown> },
    CATEGORY,
  );
}

export function trackQuestionSkipped(questionId: string): void {
  analytics.track('advisor_onboarding_questionnaire_question_skipped', { questionId }, CATEGORY);
}
